export default {
  avatar: 'Foto',

  title: 'Mein Profil',

  namePH: 'Name',
  nameTaken: 'Dieser Name ist bereits vergeben',
  nameErr: 'Dein Name darf nur aus Buchstaben und Zahlen bestehen',

  emailPH: 'Email',
  emailTaken: 'Diese Email ist bereits vergeben',
  emailErr: 'Diese Email ist ungültig',

  oldPwd: 'Altes Passwort',
  newPwd: 'Neues Passwort',
  pwdFail: 'Bitte überprüfe Deine Eingaben',

  defmedia: {
    label: 'Darstellungsformen',
    text: 'Text',
    simple: 'Einfach',
    video: 'Video',
    audio: 'Audio'
  },

  submit: 'Speichern',
  busy: 'Bitte Warten',
  submitOk: 'Dein Profil wurde erneuert',
  submitFail: '[PH]'
}



// WEBPACK FOOTER //
// ./src/i18n/profile/de.js